export default "__VITE_ASSET__CVt1w3xE__"